export const HIDDEN_QUESTIONS = [
  "Typ",
  "Vorherige Mieterhöhung",
  "Ost",
  "Wohnlage",
  "Baujahr",
];

export const HIDDEN_QUESTIONS_FOR_MIETERHOEHUNG = [
  "Vertragsdatum",
  "Datum Eintritt Mieterhöhung",
  "Kappungsgrenze durch aktuelle Mieterhöhung überschritten",
];
